module.exports = __webpack_public_path__ + "static/img/icon-certificate-badge.84c98a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reviewmng/icon-certificate-badge.png
// module id = KKAC
// module chunks = 1